import React from 'react';
import Uganda1_university_subjects from './uganda1_university_subjects';

const Uganda1_university = () => {
  return (
    <div>
     <Uganda1_university_subjects /> 
    </div>
  );
}

export default Uganda1_university;
